import { render, staticRenderFns } from "./MLTags.vue?vue&type=template&id=3f654163"
import script from "./MLTags.vue?vue&type=script&lang=js"
export * from "./MLTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports